export default "__VITE_ASSET__Y1amXvT___"